/**
 * HTML sanitization / escaping helpers.
 * NOTE: This is intentionally minimal; for richer needs (whitelisting tags) a
 * vetted library should be considered. For now we only need to neutralize text
 * fragments before concatenating into HTML strings (e.g., ECharts tooltip).
 *
 * Escapes the five primary characters that can break HTML context or enable XSS.
 *
 * @param {string|number|null|undefined} value - Raw value to escape.
 * @returns {string} Escaped string safe for HTML inclusion.
 */
export function sanitizeString(value) {
    if (value === null || value === undefined) return '';
    const str = String(value);
    // Fast-path: if it contains none of the characters needing escaping, return as-is
    if (!/[&<>"']/.test(str)) return str;
    // Avoid double-escaping existing numeric or named entities: &...; pattern
    // We'll replace ampersands only if they are NOT the start of an entity.
    // All other characters are replaced in a single pass.
    return str.replace(/&(?!#?\w+;)|[<>"]|'|"/g, ch => {
        if (ch === '&') return '&amp;';
        if (ch === '<') return '&lt;';
        if (ch === '>') return '&gt;';
        if (ch === '"') return '&quot;';
        if (ch === "'") return '&#39;';
        return ch;
    });
}
